import request from "@/api/request";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

// This is for manual testing, is hidden unless mode is set to verify
@Component({})
export default class VerifyForm extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("area", patientNamespace)
  area!: string;

  comment = "";

  error = "";

  showThankYou = false;

  passEnabled = true;
  resultMessage = "";

  get expectedResults() {
    return _.get(
      this,
      "current.census.admitDiagnosis",
      "admitDiagnosis was not defined on the patient"
    );
  }

  async sendResult(success: boolean) {
    this.passEnabled = false;
    this.error = "";
    const testName = encodeURIComponent(
      `${this.current.census.room},${this.current.census.opSys}`
    );
    const comment = encodeURIComponent(this.comment);
    const data = {
      action: "testResult",
      testName,
      success,
      comment,
      area: this.area,
      roomSys: this.current.census.roomSys
    };
    try {
      const result = await request.verifyRequest(data);
      if (result.roomSys) {
        this.$router.push({
          name: "body",
          params: {
            room: result.roomSys
          }
        });
        this.passEnabled = true;
        this.comment = "";
      } else {
        if (result.message) {
          if (result.message === "No rooms left.") {
            this.showThankYou = true;
          }
          this.resultMessage = result.message;
          this.error = this.resultMessage;
        }
        setTimeout(this.moveToCensus, 1000);
      }
    } catch (e) {
      this.error = "Failed to save";
    }
  }

  moveToCensus() {
    this.$router.push({
      name: "census",
      params: {
        area: this.area,
        view: "Grid"
      }
    });
  }
}
